import './Experience.css';

import { useTranslation } from 'react-i18next';

import experienceData from '../../data/experienceData';
import skillsData from '../../data/skillsData';

function Experience() {

  const { t } = useTranslation();

  return (

    <section className="experience" id="experience">

      <div className="experience-container">

        <div className="experience-header">

          <p className="section-label">
            {t('experience.label')}
          </p>

          <h2>
            {t('experience.title')}
          </h2>

        </div>

        <div className="experience-content">

          <div className="timeline">

            {experienceData.map((item, index) => (

              <article
                className="experience-item"
                key={index}
              >

                <span>
                  {item.period}
                </span>

                <h3>
                  {item.role}
                </h3>

                <h4>
                  {item.company}
                </h4>

                <p>
                  {item.description}
                </p>

              </article>

            ))}

          </div>

          <div className="skills">

            <h3>
              {t('experience.skillsTitle')}
            </h3>

            <ul>

              {skillsData.map((skill, index) => (

                <li key={index}>
                  {skill}
                </li>

              ))}

            </ul>

          </div>

        </div>

      </div>

    </section>

  );

}

export default Experience;